import { createMemoryHistory, createRouter, type RouteRecordRaw } from 'vue-router'
import { indexRoute } from './routes'

export const routes: RouteRecordRaw[] = [indexRoute]

export const router = createRouter({
  history: createMemoryHistory(),
  routes,
})
